import React from 'react';

export const Logo = (props) => (
  <svg
    fill="none"
    height="73"
    viewBox="0 0 71 73"
    width="71"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      fill="white"
      height="48.497"
      transform="matrix(0.999886 0.0150987 -0.0152775 0.999883 13.6335 11.4453)"
      width="44.023"
    />
    <path
      clipRule="evenodd"
      d="M50.2077 5.372L20.6201 5.29734C12.387 5.2768 5.67905 11.9114 5.66768 20.0896L5.62279 51.812C5.61087 59.9902 12.3 66.6584 20.5331 66.6789L50.1213 66.7536C58.3521 66.7745 65.0618 60.1396 65.0737 51.9615L65.1186 20.239C65.1299 12.0608 58.4387 5.39232 50.2077 5.372ZM56.2904 51.9397C56.2853 55.3062 53.5214 58.0402 50.1333 58.0317L38.4167 58.0022L38.4403 41.4654L32.2924 41.4504L32.2689 57.9867L20.5479 57.9572C17.1577 57.9484 14.4057 55.2027 14.4105 51.8344L14.4554 20.1114C14.46 16.7447 17.22 14.0109 20.6097 14.0196L32.1422 14.0488L32.1182 30.9528L38.2644 30.9686L38.2883 14.064L50.1957 14.0941C53.5832 14.1026 56.3396 16.8483 56.3348 20.2171L56.2904 51.9397Z"
      fill="#6515DD"
      fillRule="evenodd"
    />
  </svg>
);
